// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_il-0";
export var actionModalContentContainer = "_il-1";
export var createTagButton = "_il-2";
export var footerContainer = "_il-7";
export var fullWidthDivider = "_il-3";
export var hasCreateTagButton = "_il-4";
export var noCreateTagButton = "_il-5";
export var tagsContainer = "_il-6";
export var tagsModalContentContainer = "_il-8";